export function createSsl(code, inviteGameId = null) {
  return {
    type: 'CREATE_SSL',
    code,
    inviteGameId,
  };
}

export function createSslCompletion(
  error = null,
  data = {},
  inviteGameId = null
) {
  return {
    type: 'CREATE_SSL_COMPLETION',
    error,
    data,
    inviteGameId,
  };
}

export function loadSslHelpList(gameId) {
  return {
    type: 'LOAD_SSL_HELP_LIST',
    gameId,
  };
}

export function loadSslHelpListCompletion(
  gameId,
  error = null,
  list = [],
  count = 0
) {
  return {
    type: 'LOAD_SSL_HELP_LIST_COMPLETION',
    gameId,
    error,
    list,
    count,
  };
}
export function loadSslDetailWithProductCode(productCode) {
  return {
    type: 'LOAD_SSL_DETAIL_WITH_PRODUCT_CODE',
    productCode,
  };
}
export function loadSslDetailWithProductCodeCompletion(
  productCode,
  error = null,
  data = {}
) {
  return {
    type: 'LOAD_SSL_DETAIL_WITH_PRODUCT_CODE_COMPLETION',
    productCode,
    error,
    data,
  };
}
export function loadSslDetailWithGameId(gameId) {
  return {
    type: 'LOAD_SSL_DETAIL_WITH_GAME_ID',
    gameId,
  };
}
export function loadSslDetailWithGameIdCompletion(
  gameId,
  error = null,
  data = {}
) {
  return {
    type: 'LOAD_SSL_DETAIL_WITH_GAME_ID_COMPLETION',
    gameId,
    error,
    data,
  };
}
